// Which "nothing to show" line the swap panel renders, if any.
//
// Extracted so the one rule that matters here is assertable without a DOM:
// "Nothing matched" may only ever describe a search that actually ran and came
// back empty. The panel used to render it off `results === null`, and a
// request that failed set `results = []` — so a dropped connection, and (with
// search firing only on Enter) a query still being typed, both read to the
// user as a statement about the catalog. A tester nearly concluded there were
// no egg recipes while "Buttered Egg Spätzle" sat a few inches up the panel.
//
// Returns null when the list has something in it or there is nothing honest to
// say.
export default function searchEmptyState({
  searchActive,
  searching,
  searchFailed,
  results,
  searchedTerm,
  alternativesCount,
}) {
  if (searching) return "Searching…";
  if (searchFailed) return "Couldn't run that search. Check your connection and try again.";
  if (searchActive && results !== null && results.length === 0) {
    return `Nothing matched “${searchedTerm}”. Try another word.`;
  }
  if (!searchActive && alternativesCount === 0) {
    return "No alternatives for this slot — try a search below.";
  }
  return null;
}
